import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

//------------------------------------------------------------------------------
//                  Отправить запрос на добавление реакции
//------------------------------------------------------------------------------
export const changeReaction = async (data) => {
  try {
    const endpoint = `${ backendUrl }/api/comments/reactions/create/`;
    const options = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    };
    const response = await fetchWithAuth(endpoint, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при изменении реакций: HTTP error! Status: ${ response.status }`);
    }
    return await response.json();
  } catch (error) {
    console.error('Программная ошибка изменения реакций:', error);
    throw error;
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
